import {atom} from "recoil";
import {persistAtomEffect} from "../effects/persistAtom";

export const selectedEntityItemsState = atom<Guid[]>({
  key: 'SelectedEntityItemsState',
  default: [],
  effects: []
});
